// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__jcTG-","buttons":"PendingPaymentAlert_buttons__I19LP"};